export default function GlassCard({ children, className = '' }) {
  return (
    <div className={`backdrop-blur-lg bg-white/10 dark:bg-gray-900/50 border border-white/20 dark:border-gray-700/50 rounded-xl shadow-lg ${className}`}>
      {children}
    </div>
  );
}
